module.exports = __webpack_public_path__ + "img/board_title-en.f5e97472.png";